jQuery(document).ready(function($){
  $('.mMenu').on('click',function(){
    $('#site-header').toggleClass('navOpen');
		$('body').toggleClass('noScroll');
  });

	// Header scroll function
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('#site-header').outerHeight();
	$(window).scroll(function(event){
		didScroll = true;
	});
	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);
	function hasScrolled() {
		var st = $(this).scrollTop();
		if (st==0) {

			if($("body").hasClass("menuOpen")) {
				$('#site-header').addClass('scrolled white-menu');
			}
			else {
				$('#site-header').removeClass('scrolled white-menu');
			}

		}
		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
		return;
		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight){
			// Scroll Down
			$('#site-header').removeClass('white-menu').addClass('scrolled');
			
		} else {
			// Scroll Up
			if(st + $(window).height() < $(document).height()) {
				$('#site-header').addClass('white-menu');
			}
		}
		lastScrollTop = st;
	}


	(function($) {

		/* Document ready functions */
		$(document).ready(function (){


			$(".menu-item-has-children").each(function(){
				$(this).append('<div class="subnavarrow fa fa-angle-down"></div>');
			});
			$( document ).on( 'click', '.menu-item-has-children .fa', function () {
				$(this).prev().slideToggle();
				$(this).toggleClass("fa-angle-up");
				$(this).toggleClass("fa-angle-down");
			});


		});

	})(jQuery);


});
